import React from 'react';
import classNames from 'classnames';
import Icon from '../icon';

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
function FieldStatus({
  text = 'Invalid input',
  glyph = 'alert-circle',
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  className = null,
  isStatic = false,
  ...otherProps
}) {
  const classes = classNames('ws-field-status', className, { 'ws-field-status--static': isStatic });
  const iconSize = 24;

  return (
    <div {...otherProps} className={classes}>
      <Icon glyph={glyph} size={iconSize} />
      {text}
    </div>
  );
}

export default FieldStatus;
